<ion-header>
  <ion-toolbar color="primary" class="consent-header">
    <ion-buttons slot="start">
      <ion-back-button text=""></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="(consentHtml$ | async) as consent; else loading">
  <ng-container>
    <ion-content class="ion-padding" fullscreen>
        <!--<app-read-article [article]="article" (externalLink)="openLink($event)"></app-read-article>-->
      
        <div *ngIf="consent" [innerHTML]=consent></div>
    </ion-content>
    <ion-footer class="auth-footer">
      <ion-toolbar color="primary">
        <ion-item lines="none" class="auth-consent-checkbox-parent">
          <ion-label>I agree to the above</ion-label>
          <ion-checkbox [(ngModel)]="agreedToTerms" [ngModelOptions]="{standalone: true}" class="auth-consent-checkbox"></ion-checkbox>
        </ion-item>
      </ion-toolbar>
      <ion-toolbar color="primary">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-button expand="block" type="button" [disabled]="!agreedToTerms" (click)="confirmConsent()" class="auth-button primary">
                Continue
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-footer>
  </ng-container>
</ng-container>
<ng-template #loading>
  <ion-content *ngIf="isFinishedLoading" class="ion-padding" fullscreen>
    <info-capsule title="Can't proceed with registration" color="warning"
        iconCharacter="i">Make sure you have a stable internet connection and try again.</info-capsule>
  </ion-content>
  <ng-container *ngIf="!isFinishedLoading">
    <ion-content class="ion-padding" fullscreen>
      <loader></loader>
    </ion-content>
    <ion-footer>
      <ion-toolbar color="primary">
        <ion-item lines="none" class="auth-consent-checkbox-parent">
          <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
        </ion-item>
      </ion-toolbar>
      <ion-toolbar color="primary">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-footer>
  </ng-container>
</ng-template>